<template>
  <div class="datepickers-wrapper">

    <div class="item">
      <div class="icon">
        <b-icon icon="calendar3"></b-icon>
      </div>

      <div class="datepicker-wrapper">
        <datepicker :value="startDate" :disabled-dates="startDateSettings.disabledDates" @selected="startDateOnChange" :format="datepickerFormat"/>
      </div>
    </div>

    <div class="item">
      <div class="icon">
        <b-icon icon="calendar3"></b-icon>
      </div>

      <div class="datepicker-wrapper">
        <datepicker :value="endDate" :disabled-dates="endDateSettings.disabledDates" @selected="endDateOnChange" :format="datepickerFormat"/>
      </div>
    </div>

  </div>
</template>

<script>
  // Components
  import Datepicker from 'vuejs-datepicker';

  // Mixins
  import {mixinDatesHandler} from '@/mixins/dates-handler';

  // Configs
  import DatesConfig from '@/configs/dates';

  // Constants
  const IPO_START_DATE_FORMAT         = DatesConfig.IPO_START_DATE_FORMAT;
  const UI_DATE_PICKER_DATE_FORMAT    = DatesConfig.UI_DATE_PICKER_DATE_FORMAT;
  const UI_MOMENT_COMPARE_DATE_FORMAT = DatesConfig.UI_MOMENT_COMPARE_DATE_FORMAT;

  export default {
    name: 'Datepickers',

    props: {
      startDateProp: String,
      endDateProp: String,
    },

    mixins: [mixinDatesHandler],

    components: {
      Datepicker,
    },

    data() {
      return {
        startDate: null,
        endDate: null,
        datepickerFormat: UI_DATE_PICKER_DATE_FORMAT,

        endDateSettings: {
          disabledDates: {
            to: null,
            from: null
          }
        },
        startDateSettings: {
          disabledDates: {
            to: null,
            from: null
          }
        }
      }
    },

    methods: {
      startDateOnChange(date) {
        const startDate = this.$moment(date);
        const endDate   = this.$moment(this.endDate);

        this.startDate = startDate.format(UI_MOMENT_COMPARE_DATE_FORMAT);

        if (this.$moment(startDate).isAfter(endDate)) {
          this.endDate = startDate.format(UI_MOMENT_COMPARE_DATE_FORMAT);
        }

        this.$emit('onDateChange', {
          startDate: this.startDate,
          endDate: this.endDate
        });
      },

      endDateOnChange(date) {
        const startDate = this.$moment(this.startDate);
        const endDate   = this.$moment(date);

        this.endDate = endDate.format(UI_MOMENT_COMPARE_DATE_FORMAT);

        if (this.$moment(endDate).isBefore(startDate)) {
          this.startDate = endDate.format(UI_MOMENT_COMPARE_DATE_FORMAT);
        }

        this.$emit('onDateChange', {
          startDate: this.startDate,
          endDate: this.endDate
        });
      },

      initDatePickers() {
        // Set disabled days
        let ipoStartDate = this.$moment(process.env.VUE_APP_IPO_START_DATE, IPO_START_DATE_FORMAT);
        let startDateMax = this.$moment();

        const year  = parseInt(ipoStartDate.format('YYYY'));
        const month = parseInt(ipoStartDate.format('MM')) - 1; // JS new date month starts at 0
        const day   = parseInt(ipoStartDate.format('DD'));

        // Set disabled days for startDate
        const yearMax  = parseInt(startDateMax.format('YYYY'));
        const monthMax = parseInt(startDateMax.format('MM')) - 1; // JS new date month starts at 0
        const dayMax   = parseInt(startDateMax.format('DD'));

        this.startDateSettings.disabledDates.to   = new Date(year, month, day);
        this.startDateSettings.disabledDates.from = new Date(yearMax, monthMax, dayMax);

        // Set disabled days for endDate
        this.endDateSettings.disabledDates.from = new Date();
        this.endDateSettings.disabledDates.to   = new Date(year, month, day);

        // Set start and end dates
        this.endDate = this.$moment().format(UI_MOMENT_COMPARE_DATE_FORMAT);

        let startDate = this.$moment().subtract(1, 'year');
        if (this.$moment(startDate).isBefore(ipoStartDate)) {
          startDate = ipoStartDate;
        }

        this.startDate = this.$moment(startDate).format(UI_MOMENT_COMPARE_DATE_FORMAT)

        this.$emit('onInit', {
          startDate: this.startDate,
          endDate: this.endDate
        });
      },
    },

    mounted: function () {
      this.$nextTick(function () {
        this.initDatePickers();
      });
    },

    watch: {
      'startDateProp': function (newVal) {
        this.startDateOnChange(newVal);
      },
      'endDateProp': function (newVal) {
        this.endDateOnChange(newVal);
      },
    }
  }
</script>

<style scoped lang="scss">
.datepickers-wrapper {
  width: 100%;

  .item {
    width: 100%;
    display: flex;
    margin-bottom: 30px;

    .icon {
      font-size: 18px;
      line-height: 18px;
      display: inline-block;
      padding: 9px;
      border-top: 1px solid #dedede;
      border-bottom: 1px solid #dedede;
      border-left: 1px solid #dedede;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }

    .datepicker-wrapper {
      width: 100%;
      ::v-deep.vdp-datepicker {
        width: 100%;

        input {
          width: 100%;
          height: 38px;
          border: 1px solid #dedede;
          padding-left: 10px;
        }

        .vdp-datepicker__calendar {
          left: -38px;
        }
      }
    }
  }

  @media (min-width: $lgBreakpoint) {
    display: flex;

    .item {
      max-width: 170px;

      &:first-child {
        padding-right: 7.5px;
      }

      &:last-child {
        padding-left: 7.5px;
      }
    }
  }
}
</style>
